import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBreadcrumbBackUrl } from "components/shared/breadcrumbs";

// Where it goes is the trail's parent: change `breadcrumb.parent`, not this button.
const BackButton = () => {
  const { t } = useTranslation();
  const backUrl = useBreadcrumbBackUrl();

  // Nothing above the page may be opened; a link into access-denied reads worse.
  if (!backUrl) return null;

  return (
    <Link
      to={backUrl}
      className="cursor-pointer h-[43.75px] px-1 bg-transparent rounded-md inline-flex justify-center items-center gap-2.5"
    >
      <span className="text-xs font-medium">{t("back")}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        className="ltr:rotate-180"
      >
        <path
          d="M0.75 6.77441L15.75 6.77441"
          stroke="#0A0A0A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.7998 0.749828L0.749804 6.77383L6.7998 12.7988"
          stroke="#0A0A0A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
  );
};

export default BackButton;
